module.exports = __webpack_public_path__ + "assets/img/311d-gs.svg";